export class UserDocumentDTO {
    fileBase64Content: string;
    fileName: string;
    type: string;
    uid: string;
    file: File;
}